export const SummarizeLearningIcon = ({ height, width }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      version='1.1'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      height={height}
      width={width}
      x='0'
      y='0'
      viewBox='0 0 682.667 682.667'
      style={{ enableBackground: 'new 0 0 512 512' }}
      xmlSpace='preserve'
      className=''>
      <g>
        <defs strokeWidth='11' style={{ strokeWidth: 11 }}>
          <clipPath
            id='a'
            clipPathUnits='userSpaceOnUse'
            strokeWidth='11'
            style={{ strokeWidth: 11 }}>
            <path
              d='M0 512h512V0H0Z'
              fill='#000000'
              opacity='1'
              data-original='#000000'
              strokeWidth='11'
              style={{ strokeWidth: 11 }}></path>
          </clipPath>
        </defs>
        <g
          clipPath='url(#a)'
          transform='matrix(1.33333 0 0 -1.33333 0 682.667)'
          strokeWidth='11'
          style={{ strokeWidth: 11 }}>
          <path
            d='M0 0v-443.212c0-3.688 3.01-6.724 6.702-6.724h381.26c3.692 0 6.731 3.036 6.731 6.724v406.843l-.028 4.17c0 .595-.086 1.05-.285 1.475h-54.409c-14.823 0-26.977 12.142-26.977 26.979l.057 50.469c-.54.255-1.051.34-1.761.34H6.702C3.01 47.064 0 44.058 0 40.369Z'
            style={{ fillOpacity: 1, fillRule: 'evenodd', stroke: 'none', strokeWidth: 11 }}
            transform='translate(18.5 457.435)'
            fill='#ffffff'
            data-original='#f9f7f7'
            strokeWidth='11'
            className=''
            opacity='1'></path>
          <path
            d='M0 0c51.569-53.079 85.135-139.633 85.135-237.394 0-21.191-1.59-41.844-4.572-61.731a398.04 398.04 0 0 0-3.322-18.922 381.886 381.886 0 0 0-5.112-22.128C54.295-408.006 19.339-463.894-25.216-497h174.358c3.692 0 6.731 3.035 6.731 6.724v406.842l-.029 4.17c0 .596-.085 1.05-.284 1.476L74.23-.341c-.539.256-1.05.341-1.76.341h-5.027z'
            style={{ fillOpacity: 1, fillRule: 'evenodd', stroke: 'none', strokeWidth: 11 }}
            transform='translate(257.32 504.5)'
            fill='#e2e2e2'
            data-original='#e2e2e2'
            strokeWidth='11'
            className=''></path>
          <path
            d='m0 0-.057-50.469c0-14.837 12.154-26.978 26.977-26.978h54.41c-.455.907-1.477 1.702-3.522 3.659L4.316-3.772C2.044-1.588 1.022-.511 0 0'
            style={{ fillOpacity: 1, fillRule: 'evenodd', stroke: 'none', strokeWidth: 11 }}
            transform='translate(331.55 504.16)'
            fill='#cecece'
            data-original='#cecece'
            strokeWidth='11'
            className=''></path>
          <path
            d='m0 0-.057-50.469c0-14.837 12.154-26.978 26.977-26.978h49.327'
            style={{
              strokeWidth: 11,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 10,
              strokeDasharray: 'none',
              strokeOpacity: 1,
            }}
            transform='translate(331.55 504.16)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'
            opacity='1'
            className=''></path>
          <path
            d='M0 0v-226.84c0-3.688-3.039-6.723-6.73-6.723h-381.261c-3.692 0-6.702 3.035-6.702 6.723V7.461m0 34.667v214.613c0 3.689 3.01 6.696 6.702 6.696h304.588c2.045 0 2.613-.823 6.077-4.114l73.123-69.646'
            style={{
              strokeWidth: 11,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 10,
              strokeDasharray: 'none',
              strokeOpacity: 1,
            }}
            transform='translate(413.193 241.064)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'
            opacity='1'
            className=''></path>
          <path
            d='M0 0c-21.554-2.411-22.775 23.178-30.925 21.646-5.736-1.106-7.525-9.986-14.568-18.922-7.496-9.533-14.056-5.872-21.439 1.475-16.471 16.341-18.771-18.808-38.819-.426'
            style={{
              strokeWidth: 11,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 10,
              strokeDasharray: 'none',
              strokeOpacity: 1,
            }}
            transform='translate(330.245 64.976)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'
            opacity='1'
            className=''></path>
          <path
            d='m0 0 38.876-11.604 9.939 33.221c3.18 10.696-2.954 22.043-13.631 25.22C24.479 50.043 13.12 43.915 9.939 33.22Z'
            style={{ fillOpacity: 1, fillRule: 'evenodd', stroke: 'none', strokeWidth: 11 }}
            transform='translate(423.16 447.053)'
            fill='#cecece'
            data-original='#cecece'
            strokeWidth='11'
            className=''></path>
          <path
            d='m0 0 3.891-34.354c.397-2.242.369-2.356 1.987-.596L27.971-8.341l23.797 28.653-22.349 27.122-33.565-10.441Z'
            style={{ fillOpacity: 1, fillRule: 'evenodd', stroke: 'none', strokeWidth: 11 }}
            transform='translate(325.644 101.118)'
            fill='#838383'
            data-original='#838383'
            strokeWidth='11'
            className=''></path>
          <path
            d='m0 0-90.587-302.983 27.942-8.34 27.972-8.341L49.269-38.923l6.645 22.214c1.419 4.681-1.278 9.674-5.963 11.063L11.075 5.958C6.389 7.348 1.391 4.681 0 0'
            style={{ fillOpacity: 1, fillRule: 'evenodd', stroke: 'none', strokeWidth: 11 }}
            transform='translate(412.085 441.095)'
            fill='#ede9fe'
            data-original='#fe9737'
            strokeWidth='11'
            className=''
            opacity='1'></path>
          <path
            d='m0 0-9.939-33.221 19.452-5.815 9.939 33.221c3.18 10.695-2.953 22.043-13.631 25.219-3.55 1.05-7.156 1.107-10.507.284C.113 14.582 2.13 7.149 0 0'
            style={{ fillOpacity: 1, fillRule: 'evenodd', stroke: 'none', strokeWidth: 11 }}
            transform='translate(452.523 474.485)'
            fill='#b5adb6'
            data-original='#b5adb6'
            strokeWidth='11'
            className=''></path>
          <path
            d='m0 0-80.052-267.692-3.89-13.05 19.423-5.787L19.424-5.788l6.645 22.214c1.419 4.68-1.278 9.674-5.964 11.063L.653 33.305c4.686-1.418 7.384-6.383 5.992-11.064Z'
            style={{ fillOpacity: 1, fillRule: 'evenodd', stroke: 'none', strokeWidth: 11 }}
            transform='translate(441.93 407.96)'
            fill='#c4b5fd'
            data-original='#f36b37'
            strokeWidth='11'
            className=''
            opacity='1'></path>
          <path
            d='m0 0-23.797-28.652-7.27-8.739 2.613-23.063c.397-2.241.369-2.356 1.988-.596l22.092 26.61L19.423-5.787z'
            style={{ fillOpacity: 1, fillRule: 'evenodd', stroke: 'none', strokeWidth: 11 }}
            transform='translate(357.989 127.218)'
            fill='#595959'
            data-original='#595959'
            strokeWidth='11'></path>
          <path
            d='m0 0 32.146-9.588L-.483-118.696'
            style={{
              strokeWidth: 11,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 10,
              strokeDasharray: 'none',
              strokeOpacity: 1,
            }}
            transform='translate(461.354 402.172)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'
            opacity='1'
            className=''></path>
          <path
            d='m0 0 38.024 127.15c1.391 4.681 6.389 7.348 11.075 5.958l38.876-11.603c4.685-1.39 7.382-6.383 5.963-11.064L3.351-192.514l-55.914 16.681L-9.911-33.221'
            style={{
              strokeWidth: 11,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 10,
              strokeDasharray: 'none',
              strokeOpacity: 1,
            }}
            transform='translate(374.062 313.944)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'
            opacity='1'
            className=''></path>
          <path
            d='m0 0 22.093 26.609L45.89 55.263l-27.972 8.341-27.942 8.339 4.146-36.993L-1.988.596C-1.59-1.646-1.619-1.76 0 0Z'
            style={{
              strokeWidth: 11,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 10,
              strokeDasharray: 'none',
              strokeOpacity: 1,
            }}
            transform='translate(331.522 66.168)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'
            opacity='1'
            className=''></path>
          <path
            d='m0 0 38.876-11.604 9.939 33.221c3.18 10.696-2.954 22.043-13.631 25.22C24.479 50.043 13.12 43.915 9.939 33.22Z'
            style={{
              strokeWidth: 11,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 10,
              strokeDasharray: 'none',
              strokeOpacity: 1,
            }}
            transform='translate(423.16 447.053)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'
            opacity='1'
            className=''></path>
          <path
            d='M0 0h203.637'
            style={{
              strokeWidth: 11,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 10,
              strokeDasharray: 'none',
              strokeOpacity: 1,
            }}
            transform='translate(113.432 309.547)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'
            opacity='1'
            className=''></path>
          <path
            d='M0 0h191.227'
            style={{
              strokeWidth: 11,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 10,
              strokeDasharray: 'none',
              strokeOpacity: 1,
            }}
            transform='translate(113.432 251.248)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'
            opacity='1'
            className=''></path>
          <path
            d='M0 0h176.432'
            style={{
              strokeWidth: 11,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 10,
              strokeDasharray: 'none',
              strokeOpacity: 1,
            }}
            transform='translate(113.432 192.95)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'
            opacity='1'
            className=''></path>
          <path
            d='M0 0h120.83'
            style={{
              strokeWidth: 11,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 10,
              strokeDasharray: 'none',
              strokeOpacity: 1,
            }}
            transform='translate(113.432 134.65)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'
            opacity='1'
            className=''></path>
          <path
            d='M0 0h-165.044c-2.811 0-5.112-2.298-5.112-5.106v-30.242c0-2.808 2.301-5.106 5.112-5.106H0c2.812 0 5.112 2.298 5.112 5.106v30.242C5.112-2.298 2.812 0 0 0'
            style={{ fillOpacity: 1, fillRule: 'evenodd', stroke: 'none', strokeWidth: 11 }}
            transform='translate(293.214 407.647)'
            fill='#059669'
            data-original='#97da7b'
            strokeWidth='11'
            className=''
            opacity='1'></path>
          <path
            d='M0 0h-46.855c2.811 0 5.111-2.298 5.111-5.106v-30.242c0-2.808-2.3-5.106-5.111-5.106H0c2.812 0 5.112 2.298 5.112 5.106v30.242C5.112-2.298 2.812 0 0 0'
            style={{ fillOpacity: 1, fillRule: 'evenodd', stroke: 'none', strokeWidth: 11 }}
            transform='translate(293.214 407.647)'
            fill='#d1fae5'
            data-original='#68ca44'
            strokeWidth='11'
            className=''
            opacity='1'></path>
          <path
            d='M0 0h165.044c2.812 0 5.112-2.298 5.112-5.106v-30.242c0-2.808-2.3-5.106-5.112-5.106H0c-2.811 0-5.111 2.298-5.111 5.106v30.242C-5.111-2.298-2.811 0 0 0Z'
            style={{
              strokeWidth: 11,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 10,
              strokeDasharray: 'none',
              strokeOpacity: 1,
            }}
            transform='translate(128.17 407.647)'
            fill='none'
            stroke='#000000'
            strokeWidth='11'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'
            opacity='1'
            className=''></path>
        </g>
      </g>
    </svg>
  );
};
